export const generateCages = (study_id: string | null = null, num = 0) => {
  const result: Array<{ study_id: string | null }> = [];
  for (let index = 0; index < num; index++) {
    result[index] = {
      study_id,
    };
  }
  return result;
};
